<template>
    <div>
        <div id="tab-sidebar-pate4">
            <div class="container">
                <div id="menu-tab-pate4" class="row">
                    <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2">
                        <router-link :to="{ name: 'ebook-detail', params: { id: this.id, slug: this.slug } }"><i
                                class="fa fa-times"></i> Thoát
                        </router-link>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
                        <span>TOAN 5</span>
                    </div>
                </div>
            </div>
        </div>
        <div id="footer-pate42">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 list-exam">
                        <button id="danhsach" class="btn btn-primary" type="button">

                            <span><i class="fa fa-bars"></i> Mục lục</span>
                        </button>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8 next-footer-ebook">
                        <div id="next-page-ebook">
                            <!--<a href="javascript:void(0)" @click="luyenTap" v-show="id==115" class="word active">Luyện tập</a>-->
                            <button @click="first">
                                <i class="fa fa-backward"></i>
                            </button>
                            <button @click="prev">
                                <i class="fa fa-caret-left"></i>

                            </button>
                            <input type="text" :value="(page-2>0?page-2:0)" disabled="disabled">
                            <button @click="next">
                                <i class="fa fa-caret-right"></i>
                            </button>
                            <button @click="last">
                                <i class="fa fa-forward"></i>
                            </button>
                        </div>
                        <div id="zoom-ebook">
                            <button @click="zoomOut">-</button>
                            <input type="text" :value="scale*100" v-on:keyup.enter="trySetNewZoom">
                            <button @click="zoomIn">+</button>
                        </div>
                        <button id="zoom-ebook-full" @click="fullScreen"><i class="fa fa-expand"></i></button>

                    </div>
                </div>
            </div>
        </div>
        <pdf :src="pdfdata" :key="page" :id="page" :page="page" :annotation="true"
             :scale.sync="scale"
             style="width:100%;margin:20px auto;">
            <template slot="loading">
                loading content here...
            </template>
        </pdf>
        <div id="text-layer">
            <!--<div v-for="hl in dictHighLight[page]">-->
                <!--<div v-if="hl !=null && hl.arrHLs!=null" class="highlight-layer" v-for="hlObj in hl.arrHLs">-->
                    <!--<div class="highlight" :style="{position: 'absolute', left: hlObj.left+'px', top: hlObj.top+'px', width: hlObj.width+'px', height: hlObj.height+'px', padding: '0px', background: 'rgb(255, 0, 0)'}"></div>-->
                <!--</div>-->
            <!--</div>-->
        </div>

        <ul class='custom-menu mnu-highlight' v-show="showTools">
            <li data-action="highlight">Đánh dấu</li>
        </ul>
        <div
            v-show="showTools"
            class="tools"
            :style="{
                left: `${x}px`,
                top: `${y}px`
            }"
            @mousedown.prevent=""
        >
          <span
                  class="item"
                  @mousedown.prevent="handleAction('highlight')"
                  title="Đánh dấu"
          >
            <svg style="width:24px;height:24px" viewBox="0 0 24 24">
              <path fill="#000000" d="M18.5,1.15C17.97,1.15 17.46,1.34 17.07,1.73L11.26,7.55L16.91,13.2L22.73,7.39C23.5,6.61 23.5,5.35 22.73,4.56L19.89,1.73C19.5,1.34 19,1.15 18.5,1.15M10.3,8.5L4.34,14.46C3.56,15.24 3.56,16.5 4.36,17.31C3.14,18.54 1.9,19.77 0.67,21H6.33L7.19,20.14C7.97,20.9 9.22,20.89 10,20.12L15.95,14.16" />
            </svg>
          </span>
        </div>
    </div>
</template>

<script>
    import pdfvuer from 'pdfvuer'
    import { APP_CONFIG } from '@/utils/constants'

    export default {
        props:{
            defaultPage: Number
        },
        data() {
            return {
                id: this.$route.params.id,
                slug: this.$route.params.slug,
                pdfdata: null,
                show: true,
                page: this.defaultPage,
                src: 'http://localhost:8011/bt-toan-5-tap-hai-protected.pdf',
                size: {
                    width: -1,
                    height: -1
                },
                numPages:0,
                pdfDoc: null,
                zoom: 50,
                pdfObj: null,
                scale: 1,

                x: 0,
                y: 0,
                showTools: false,
                selectedText: '',
                dictHighLight: {}
            }
        },
        computed: {
            currentPageHL(){
                var pageHl = this.dictHighLight[this.page];
                if(pageHl!=null && pageHl.arrHLs !=null){
                    return pageHl.arrHLs;
                }
                return null;
            }
        },
        components: {
            pdf: pdfvuer
        },
        mounted () {
            this.getPdf(this.defaultPage)
            window.addEventListener('mouseup', this.onMouseup)
        },
        beforeDestroy () {
            window.removeEventListener('mouseup', this.onMouseup)
        },
        methods:{
            getPdf (page) {
                var self = this;
                self.pdfdata = pdfvuer.createLoadingTask(APP_CONFIG.dataUrl + '/bt-toan-5-tap-2.pdf');
                self.pdfdata.then(pdf => {
                    self.numPages = pdf.numPages;
                    self.pdfObj = self;
                });
                    this.page = 1;

            },
            prev(){
                if(this.page>1){
                    this.page=this.page-1;
                    var that = this;
                    setTimeout(function(){
                        that.renderPageHighLight();
                    }, 1000);

                }
            },
            next(){
                //console.log(this.$refs.myPdfComponent.pdf)
                if(this.page<this.numPages){
                    this.page=this.page+1;

                    var that = this;
                    setTimeout(function(){
                        that.renderPageHighLight();
                    }, 1000);
                }
            },
            first(){
                this.page=1;
                this.renderPageHighLight();
            },
            last(){
                this.page=this.numPages;
                this.renderPageHighLight();
            },
            zoomIn(){
                if(this.scale <= 3){
                    this.scale = this.scale + 0.25;
                    this.renderPageHighLight();
                }
            },
            zoomOut(){
                if(this.scale > 0.25){
                    this.scale = this.scale - 0.25;
                    this.renderPageHighLight();
                }
            },
            fullScreen(){
                this.scale = 2;
                this.renderPageHighLight();
            },
            showPDF(pdf_url) {

            },
            readPage(page){
                //console.log(this.$refs.myPdfComponent.pdf)
                if(page>0 && page<this.numPages){
                    this.page=page;
                    var that = this;
                    setTimeout(function(){
                        that.renderPageHighLight();
                    }, 1000);
                }
            },
            getSelectedText() {
                if (window.getSelection) {
                    return this.TCVN3ToUnicode(window.getSelection().toString());
                } else if (document.selection) {
                    return this.TCVN3ToUnicode(document.selection.createRange().text);
                }
                return '';
            },
            onMouseup () {


                var text=this.getSelectedText();
                if (text!='' && text.length > 0) {

                    const selection = window.getSelection()
                    const startNode = selection.getRangeAt(0).startContainer.parentNode
                    console.log(startNode)
                    const endNode = selection.getRangeAt(0).endContainer.parentNode
                    const { x, y, width } = selection.getRangeAt(0).getBoundingClientRect()
                    if (!width) {
                        this.showTools = false
                        return
                    }
                    this.x = x + (width / 2)
                    this.y = y + window.scrollY - 10
                    this.selectedText = selection.toString()
                    this.showTools=true;
                }
                else{
                    this.showTools=false;
                }
            },
            handleAction (action) {
                var selection = window.getSelection();
                var getRange = selection.getRangeAt(0);
                var getRect = getRange.getBoundingClientRect();
                console.log(getRect);
                //addHighLight();
                let __CANVAS = document.getElementById('viewerContainer')
                var arrHLs=this.getClientRects(__CANVAS,getRange);

                var arrs = this.getDictHighLight(this.page);
                if(arrs != null && arrs != 'undefined'){
                    arrs.push({id: 1, content: this.getSelectedText(), arrHLs: arrHLs});
                }
                else{
                    this.addDictHighLight(this.page, [{id: 1, content: this.getSelectedText(), arrHLs: arrHLs}]);
                }

                console.log(arrHLs)

                var hl_container = document.createElement('div');
                hl_container.setAttribute('class',"highlight-layer");

                for (var i = 0, len = arrHLs.length; i < len; ++i) {
                    hl_container.appendChild(this.createRect(arrHLs[i]));
                }
                document.getElementsByClassName("textLayer")[0].append(hl_container);

                this.$emit(action, this.selectedText)
            },
            getClientRects(containerEl, range){
                let clientRects = Array.from(range.getClientRects());

                var offset = containerEl.getBoundingClientRect();
                let __SCALE = this.scale;
                var rects = [];
                console.log(clientRects)
                for (var i = 0, len = clientRects.length; i < len; ++i) {
                    var rect= clientRects[i];
                    var obj = {};
                    obj.top = rect.top + containerEl.scrollTop - offset.top;
                    obj.left = rect.left + containerEl.scrollLeft - offset.left;
                    obj.width = rect.width;
                    obj.height = rect.height;
                    rects.push(obj);
                }
                var arrRect=[];
                var _top=0,_left=0,_width=0,_height=0;
                for(var i=0;i<rects.length;i++){
                    if(i==0){
                        _top = rects[i].top;
                        _left = rects[i].left;
                        _width = rects[i].width;
                        _height = rects[i].height;
                    }
                    else{
                        if(rects[i].top > _top + 5)
                        {
                            arrRect.push({top: _top/__SCALE, left: _left/__SCALE, width: _width/__SCALE, height: _height/__SCALE});
                            _top = rects[i].top;
                            _left = rects[i].left;
                            _width = rects[i].width;
                            _height = rects[i].height;
                            if(_width ==  null || _width == 'undefined'){
                                _width = 0;
                            }
                        }
                        else{
                            if(rects[i].left > _left + 1){
                                _width = _width + rects[i].width;
                            }
                            if(_width > containerEl.width - _left)
                            {
                                _width = containerEl.width -_left;
                            }
                        }
                        if(i==rects.length-1){
                            arrRect.push({top: _top/__SCALE, left: _left/__SCALE, width: _width/__SCALE, height: _height/__SCALE});
                        }
                    }
                    if(rects.length==1){
                        arrRect.push({top: _top/__SCALE, left: _left/__SCALE, width: _width/__SCALE, height: _height/__SCALE});
                    }
                }
                console.log(rects);
                console.log(arrRect);
                return arrRect;
                console.log(rects);
                return rects;
            },
            createRect(highlight){
                //let __CANVAS = document.getElementById('viewerContainer')
                var myLayer = document.createElement('div');
                myLayer.setAttribute('class',"highlight");
                myLayer.style.position = 'absolute';
                myLayer.style.left = this.scale * highlight.left + 'px';
                myLayer.style.top = this.scale * highlight.top + 'px';
                myLayer.style.width = this.scale *  highlight.width + 'px';
                myLayer.style.height = this.scale *  highlight.height + 'px';
                myLayer.style.padding = '0px';
                myLayer.style.background = '#ff0000';
                myLayer.innerHTML = '';
                return myLayer;
            },
            renderHighLight(obj){
                var hl_container = document.createElement('div');
                hl_container.setAttribute('class',"highlight-layer");

                for (var i = 0, len = obj.arrHLs.length; i < len; ++i) {
                    hl_container.appendChild(this.createRect(obj.arrHLs[i]));
                }
                document.getElementsByClassName("textLayer")[0].append(hl_container);
            },
            renderPageHighLight(){
                console.log("renderPageHighLight")
                var arrs = this.getDictHighLight(this.page);
                console.log(arrs)
                if(arrs != null && arrs != 'undefined'){
                    for (var i = 0, len = arrs.length; i < len; ++i) {
                        this.renderHighLight(arrs[i]);
                    }
                }
            },
            addDictHighLight(myKey, myValue) {
                this.dictHighLight[myKey] = myValue;
            },
            getDictHighLight(myKey) {
                return this.dictHighLight[myKey];
            },
            setCurrentHighLight(obj){
                this.dictHighLight[this.page];
            },
            TCVN3ToUnicode(str){
                var tcvnchars = [
                    'μ', '¸', '¶', '·', '¹',
                    '¨', '»', '¾', '¼', '½', 'Æ',
                    '©', 'Ç', 'Ê', 'È', 'É', 'Ë',
                    '®', 'Ì', 'Ð', 'Î', 'Ï', 'Ñ',
                    'ª', 'Ò', 'Õ', 'Ó', 'Ô', 'Ö',
                    '×', 'Ý', 'Ø', 'Ü', 'Þ',
                    'ß', 'ã', 'á', 'â', 'ä',
                    '«', 'å', 'è', 'æ', 'ç', 'é',
                    '¬', 'ê', 'í', 'ë', 'ì', 'î',
                    'ï', 'ó', 'ñ', 'ò', 'ô',
                    '­', 'õ', 'ø', 'ö', '÷', 'ù',
                    'ú', 'ý', 'û', 'ü', 'þ',
                    '¡', '¢', '§', '£', '¤', '¥', '¦','−','¬','̧','̈'];
                var unichars = [
                    'à', 'á', 'ả', 'ã', 'ạ',
                    'ă', 'ằ', 'ắ', 'ẳ', 'ẵ', 'ặ',
                    'â', 'ầ', 'ấ', 'ẩ', 'ẫ', 'ậ',
                    'đ', 'è', 'é', 'ẻ', 'ẽ', 'ẹ',
                    'ê', 'ề', 'ế', 'ể', 'ễ', 'ệ',
                    'ì', 'í', 'ỉ', 'ĩ', 'ị',
                    'ò', 'ó', 'ỏ', 'õ', 'ọ',
                    'ô', 'ồ', 'ố', 'ổ', 'ỗ', 'ộ',
                    'ơ', 'ờ', 'ớ', 'ở', 'ỡ', 'ợ',
                    'ù', 'ú', 'ủ', 'ũ', 'ụ',
                    'ư', 'ừ', 'ứ', 'ử', 'ữ', 'ự',
                    'ỳ', 'ý', 'ỷ', 'ỹ', 'ỵ',
                    'Ă', 'Â', 'Đ', 'Ê', 'Ô', 'Ơ', 'Ư','ư','ơ','á','ă'];

                var str1=tcvnchars.join('');
                var re=new RegExp('['+str1+']','g');
                str=str.replace(re,function(c){
                    return unichars[str1.indexOf(c)]
                });
                return str;
            }
        }
    }
</script>

<style lang="scss" scoped>
    /* The whole thing */
    .custom-menu {
        z-index: 1000;
        position: absolute;
        overflow: hidden;
        border: 1px solid #CCC;
        white-space: nowrap;
        font-family: sans-serif;
        background: #FFF;
        color: #333;
        border-radius: 5px;
        padding: 0;
    }

    /* Each of the items in the list */
    .custom-menu li {
        padding: 8px 12px;
        cursor: pointer;
        list-style-type: none;
        transition: all .3s ease;
        user-select: none;
    }

    .custom-menu li:hover {
        background-color: #DEF;
    }
    .tools {
        height: 30px;
        padding: 5px 10px;
        background: #333;
        border-radius: 3px;
        position: absolute;
        top: 0;
        left: 0;
        transform: translate(-50%, -100%);
        transition: 0.2s all;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .tools:after {
        content: '';
        position: absolute;
        left: 50%;
        bottom: -5px;
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-top: 6px solid #333;
    }
    // .item {
    //     color: #fff;
    //     cursor: pointer;
    // }
    // .item path {
    //     fill: #fff;
    // }
    // .item:hover path {
    //     fill: #19f;
    // }
    // .item:hover {
    //     color: #19f;
    // }
    // .item + .item {
    //     margin-left: 10px;
    // }

</style>